import axios from "axios";

if (process.env.RAZZLE_APP_PATH) {
  var baseURL = `${process.env.RAZZLE_APP_PATH}`;
  var razorKey = `rzp_live_sDovuuBgCu9dw3`
} else {
  var baseURL = `https://api.redcliffelabs.com`;
  var razorKey = `rzp_test_kBEHIT9OH5OYyo`
}
const AXIOS = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

export default AXIOS;

export const links =  process.env.RAZZLE_APP_PATH ? `${process.env.RAZZLE_APP_PATH}/api/v1` : 'https://api.redcliffelabs.com/api/v1'

export var razorKey = process.env.RAZZLE_APP_PATH == 'https://api.redcliffelabs.com' ? `rzp_test_kBEHIT9OH5OYyo`: `rzp_live_sDovuuBgCu9dw3`